import { render } from "./TopRowTeamLeadComponent.vue?vue&type=template&id=920e62b0&scoped=true"
import script from "./TopRowTeamLeadComponent.vue?vue&type=script&lang=js"
export * from "./TopRowTeamLeadComponent.vue?vue&type=script&lang=js"

import "./TopRowTeamLeadComponent.vue?vue&type=style&index=0&id=920e62b0&lang=scss&scoped=true"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-920e62b0"]])

export default __exports__